import {
  ChangeDetectionStrategy,
  Component,
  signal,
  inject,
  DestroyRef,
} from '@angular/core';
import { ContentContainer } from '../../../../core/content-container/content-container';
import { InViewDirective } from '../../../../shared/in-view/directives/in-view.directive';
import gsap from 'gsap';

@Component({
  selector: 'app-numbers',
  standalone: true,
  imports: [ContentContainer, InViewDirective],
  templateUrl: './numbers.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Numbers {
  readonly hoursDisplay = signal<string>('+0h');
  readonly devsDisplay = signal<string>('+0');
  readonly approvalDisplay = signal<string>('0%');

  private countTween: gsap.core.Tween | null = null;
  private destroyRef = inject(DestroyRef);

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.countTween?.kill();
    });
  }

  startCountAnimation(): void {
    if (this.countTween) return;

    const counterObj = { hours: 0, devs: 0, approval: 0 };

    this.countTween = gsap.to(counterObj, {
      hours: 90,
      devs: 16000,
      approval: 97,
      duration: 2,
      ease: 'power2.out',
      onUpdate: () => {
        this.hoursDisplay.set(`+${Math.floor(counterObj.hours)}h`);
        this.devsDisplay.set(
          `+${Math.floor(counterObj.devs).toLocaleString('pt-BR')}`,
        );
        this.approvalDisplay.set(`${Math.floor(counterObj.approval)}%`);
      },
    });
  }
}
